export default __webpack_public_path__ + "static/media/lang-us-icon.7e7fe6cf.png";